import { render, staticRenderFns } from "./snackbar-icon.vue?vue&type=template&id=4c934e4f"
import script from "./snackbar-icon.vue?vue&type=script&lang=js"
export * from "./snackbar-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports